var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"context__menu-item"},[_c('a',{staticClass:"context__menu-item-link",class:{ 'context__menu-item-link--loading': _vm.loading },on:{"click":_vm.handleClick}},[_c('i',{staticClass:"context__menu-item-icon iconoir-page-edit"}),_vm._v("\n    "+_vm._s(_vm.$t('subscriptionMenuItem.content'))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }